
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdSearch, MdNotificationsNone, MdMailOutline, MdMenu, MdLogout, MdLockReset, MdPerson } from 'react-icons/md';
import { useUser } from '../context/UserContext';
import './Header.css';

const Header = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const { userProfile, refreshUserAccess } = useUser();
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const profileRef = useRef(null);

    const toggleProfile = () => {
        setIsProfileOpen(!isProfileOpen);
    };

    const getInitials = (name) => {
        if (!name) return '??';
        const names = name.split(' ');
        if (names.length >= 2) {
            return (names[0][0] + names[1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setIsProfileOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        refreshUserAccess();
        navigate('/login');
    };

    return (
        <header className="header">
            <div className="header-inner">
                <button className="menu-btn" onClick={toggleSidebar}>
                    <MdMenu />
                </button>

                <div className="search-bar">
                    {/* <MdSearch className="search-icon" /> */}
                    {/* <input
                        type="text"
                        placeholder="Search..."
                        className="search-input"
                    /> */}
                </div>

                <div className="header-actions">
                    {/* <button className="action-btn-bell">
                        <MdNotificationsNone />
                        {/* <span className="notification-badge">0</span> */}
                    {/* </button> */}

                    <div
                        className="user-profile-container"
                        ref={profileRef}
                        onClick={toggleProfile}
                    >
                        <div className="user-profile">
                            <div className="user-avatar">
                                {getInitials(userProfile?.username || userProfile?.name)}
                            </div>
                            <div className="user-info">
                                <span className="user-name">
                                    {userProfile?.username || userProfile?.name || 'Guest User'}
                                </span>
                                <span className="user-role">
                                    {userProfile?.roleName || userProfile?.role || 'User'}
                                </span>
                            </div>
                        </div>

                        {isProfileOpen && (
                            <div className="profile-dropdown">
                                <button
                                    className="profile-menu-item"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/reset-password');
                                        setIsProfileOpen(false);
                                    }}
                                >
                                    <MdLockReset size={18} />
                                    <span>Reset Password</span>
                                </button>
                                <button
                                    className="profile-menu-item"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/profile');
                                        setIsProfileOpen(false);
                                    }}
                                >
                                    <MdPerson size={18} />
                                    <span>Profile</span>
                                </button>
                                <button className="profile-menu-item" onClick={handleLogout}>
                                    <MdLogout size={18} />
                                    <span>Logout</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header >
    );
};

export default Header;
